import { render, staticRenderFns } from "./NavBarLibraryIndex.vue?vue&type=template&id=3bf35217&"
import script from "./NavBarLibraryIndex.vue?vue&type=script&lang=js&"
export * from "./NavBarLibraryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports